var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListingpinkicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.996,
    height: 15.153,
    viewBox: "47.502 492.424 16.996 15.153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 99"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 12 \\u2013 33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m56 495.826-6.448 5.705c-.048.043-.11.063-.162.099v5.473c0 .262.212.474.472.474h4.404l-1.099-2.155 3.072-1.894-1.775-3.529 4.369 4.049-3.072 1.894 1.177 1.635h5.2c.26 0 .471-.212.471-.474v-5.472c-.05-.034-.11-.054-.155-.095L56 495.826Zm8.341 3.59-1.732-1.533v-4.039a.473.473 0 0 0-.472-.473H60.25a.473.473 0 0 0-.472.473v1.53l-2.988-2.645a1.178 1.178 0 0 0-1.577-.001l-7.553 6.689a.475.475 0 0 0-.036.669l.631.705c.174.194.473.21.667.035l6.767-5.986a.471.471 0 0 1 .624 0l6.767 5.986a.472.472 0 0 0 .667-.036l.631-.705a.474.474 0 0 0-.036-.668Z",
    fill: "#df1681",
    fillRule: "evenodd",
    "data-name": "Icon awesome-house-damage"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.969 498.467h2.676c1.184 0 2.143.96 2.143 2.143v4.824c0 1.183-.96 2.143-2.143 2.143H53.44c-1.183 0-.613-.96-.613-2.143v-4.824c0-1.184.96-2.143 2.143-2.143Z",
    fill: "#df1681",
    fillRule: "evenodd",
    "data-name": "Path 35"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.046 501.288a2.235 2.235 0 0 1-2.652 2.196l-.305.343a.305.305 0 0 1-.227.102h-.473v.508a.305.305 0 0 1-.305.305h-.508v.508a.305.305 0 0 1-.305.305H52.85a.305.305 0 0 1-.305-.305v-.991c0-.081.033-.159.09-.216l2.054-2.054a2.235 2.235 0 1 1 4.358-.7Zm-2.235-.61a.61.61 0 1 0 1.22 0 .61.61 0 0 0-1.22 0Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Icon awesome-key"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListingpinkicon);
export default __webpack_public_path__ + "static/media/listingpinkicon.8d7ade4876e4e3f357918d9a618354f6.svg";
export { ForwardRef as ReactComponent };